if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        let activeMediaNode = activeMedia;

        if (activeMediaNode.tagName.toLocaleUpperCase() !== 'IMG') {
          activeMediaNode = activeMediaNode.querySelector('img');
        }
        let mediaSrc = activeMediaNode.getAttribute('data-src');
        if (mediaSrc) {
          activeMediaNode.src = mediaSrc;
          const srcset = activeMediaNode.getAttribute('data-srcset');
          if (srcset) {
            activeMediaNode.srcset = activeMediaNode.getAttribute('data-srcset');
            activeMediaNode.removeAttribute('data-srcset');
          }
          activeMediaNode.removeAttribute('data-src');
        }
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
        activeMedia.loadContent();

        if (activeMediaNode) {
          // 打开弹窗自动播放
          const deferredMediaNode = activeMediaNode.closest('deferred-media');
          if (deferredMediaNode) {
            deferredMediaNode.loadContent();
          }
        }
      }
    }
  );
}
